// extracted by css-extract-rspack-plugin
export default {"Home":"src-pages-Home-module__Home-NtBtoG","home":"src-pages-Home-module__Home-NtBtoG","App-logo":"src-pages-Home-module__App-logo-BEiC0G","appLogo":"src-pages-Home-module__App-logo-BEiC0G","viewSlidesList":"src-pages-Home-module__viewSlidesList-sIj25J"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"Home\":\"src-pages-Home-module__Home-NtBtoG\",\"home\":\"src-pages-Home-module__Home-NtBtoG\",\"App-logo\":\"src-pages-Home-module__App-logo-BEiC0G\",\"appLogo\":\"src-pages-Home-module__App-logo-BEiC0G\",\"viewSlidesList\":\"src-pages-Home-module__viewSlidesList-sIj25J\"}";
        // 1793732227533
        var cssReload = require("../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  